/**
 * Swiper Initialization Module
 * Handles all Swiper carousel instances
 */

document.addEventListener('DOMContentLoaded', function () {
  // Check if Swiper library is loaded
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper library not loaded')
    return
  }

  // Common Swiper configuration
  /** Fisher–Yates shuffle of direct children (used for fan-favourites carousels). */
  function shuffleElementChildren(wrapper) {
    const children = Array.from(wrapper.children)
    for (let i = children.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[children[i], children[j]] = [children[j], children[i]]
    }
    children.forEach((child) => wrapper.appendChild(child))
  }

  const fanFavouritesSelectors = [
    '.fan-favourites-swiper',
    '.fan-favourites-swiper-men',
    '.fan-favourites-swiper-women',
    '.fan-favourites-swiper-accessories',
  ]
  fanFavouritesSelectors.forEach((selector) => {
    const wrapper = document.querySelector(selector + ' .swiper-wrapper')
    if (wrapper) shuffleElementChildren(wrapper)
  })

  const createSwiperConfig = (paginationClass, customBreakpoints = null) => ({
    slidesPerView: 'auto',
    spaceBetween: 8,
    pagination: {
      el: paginationClass,
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 3,
    },
    breakpoints: customBreakpoints || {
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
    },
  })

  const swipers = [
    {
      selector: '.fan-favourites-swiper',
      pagination: '.fan-favourites-pagination-all',
    },
    {
      selector: '.fan-favourites-swiper-men',
      pagination: '.fan-favourites-pagination-men',
    },
    {
      selector: '.fan-favourites-swiper-women',
      pagination: '.fan-favourites-pagination-women',
    },
    {
      selector: '.fan-favourites-swiper-accessories',
      pagination: '.fan-favourites-pagination-accessories',
    },
    {
      selector: '.similar-products-swiper',
      pagination: '.similar-products-pagination',
    },
    {
      selector: '.cart-recommendations-swiper',
      pagination: '.cart-recommendations-pagination',
    },
    {
      selector: '.collection-categories-swiper',
      pagination: '.collection-categories-pagination',
    },
  ]

  swipers.forEach(function (item) {
    const element = document.querySelector(item.selector)
    if (element && !element.swiper) {
      let config

      // Custom config for similar-products and cart-recommendations with 308px cards
      if (item.selector === '.similar-products-swiper' || item.selector === '.cart-recommendations-swiper') {
        config = {
          slidesPerView: 'auto',
          spaceBetween: 8,
          pagination: {
            el: item.pagination,
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 12,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 12,
            },
          },
        }
      } else if (item.selector === '.collection-categories-swiper') {
        // Collection categories swiper - 3 on mobile, 6 on desktop
        config = {
          slidesPerView: 3,
          spaceBetween: 16,
          pagination: {
            el: item.pagination,
            clickable: true,
          },
          breakpoints: {
            1024: {
              slidesPerView: 6,
              spaceBetween: 16,
            },
          },
          on: {
            init: function (swiper) {
              // Animate in after initialization
              requestAnimationFrame(() => {
                swiper.el.classList.remove('!invisible', '!opacity-0', '!translate-y-4')
              })
            },
          },
        }
      } else {
        config = createSwiperConfig(item.pagination)
      }

      item.instance = new Swiper(item.selector, config)
    }
  })

  // Sale landing category rows: several carousels share one class, so init each,
  // wiring its own pagination dots + next arrow (elements live in the same column).
  document.querySelectorAll('.sale-row-swiper').forEach(function (el) {
    if (el.swiper) return
    var col = el.parentElement
    var nextEl = col ? col.querySelector('.sale-row-next') : null
    var pagEl = col ? col.querySelector('.sale-row-pagination') : null
    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      grabCursor: true,
      loop: true,
      pagination: pagEl ? { el: pagEl, clickable: true } : false,
      navigation: nextEl ? { nextEl: nextEl } : false,
      breakpoints: {
        768: { spaceBetween: 12 },
      },
    })
  })

  // Sale category banner: square creative (object-contain, never cropped). A flex
  // item can't derive its width from its own height, so on desktop we measure the
  // tallest carousel, pad every carousel to it, and set every banner to that same
  // square — uniform banners, all flush with their row, no gaps.
  function sizeSaleBanners() {
    var banners = document.querySelectorAll('.sale-cat-banner')
    var carousels = document.querySelectorAll('.sale-row-swiper')
    if (!banners.length) return
    if (window.innerWidth < 1024) {
      banners.forEach(function (b) {
        b.style.width = ''
      })
      carousels.forEach(function (c) {
        c.style.minHeight = ''
      })
      return
    }
    // Measure natural heights (clear any imposed minimum first), then unify.
    carousels.forEach(function (c) {
      c.style.minHeight = ''
    })
    var maxH = 0
    carousels.forEach(function (c) {
      if (c.offsetHeight > maxH) maxH = c.offsetHeight
    })
    if (!maxH) return
    carousels.forEach(function (c) {
      c.style.minHeight = maxH + 'px'
    })
    banners.forEach(function (b) {
      b.style.width = maxH + 'px'
    })
  }

  var sizeScheduled = false
  function scheduleSizeSaleBanners() {
    if (sizeScheduled) return
    sizeScheduled = true
    requestAnimationFrame(function () {
      sizeScheduled = false
      sizeSaleBanners()
    })
  }
  sizeSaleBanners()
  window.addEventListener('load', scheduleSizeSaleBanners)
  window.addEventListener('resize', scheduleSizeSaleBanners)
  // Re-sync as images/review badges settle and change the carousel height.
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(scheduleSizeSaleBanners)
    document.querySelectorAll('.sale-row-swiper').forEach(function (el) {
      ro.observe(el)
    })
  }
})
